import { publicKey, struct, u64, u8, option } from "@project-serum/borsh";
var AccountType = /* @__PURE__ */ ((AccountType2) => {
  AccountType2[AccountType2["Uninitialized"] = 0] = "Uninitialized";
  AccountType2[AccountType2["StakePool"] = 1] = "StakePool";
  AccountType2[AccountType2["ValidatorList"] = 2] = "ValidatorList";
  return AccountType2;
})(AccountType || {});
const feeFields = [u64("denominator"), u64("numerator")];
const StakePoolLayout = struct([
  u8("accountType"),
  publicKey("manager"),
  publicKey("staker"),
  publicKey("stakeDepositAuthority"),
  u8("stakeWithdrawBumpSeed"),
  publicKey("validatorList"),
  publicKey("reserveStake"),
  publicKey("poolMint"),
  publicKey("managerFeeAccount"),
  publicKey("tokenProgramId"),
  u64("totalLamports"),
  u64("poolTokenSupply"),
  u64("lastUpdateEpoch"),
  struct(
    [u64("unixTimestamp"), u64("epoch"), publicKey("custodian")],
    "lockup"
  ),
  struct(feeFields, "epochFee"),
  option(struct(feeFields), "nextEpochFee"),
  option(publicKey(), "preferredDepositValidatorVoteAddress"),
  option(publicKey(), "preferredWithdrawValidatorVoteAddress"),
  struct(feeFields, "stakeDepositFee"),
  struct(feeFields, "stakeWithdrawalFee"),
  option(struct(feeFields), "nextStakeWithdrawalFee"),
  u8("stakeReferralFee"),
  option(publicKey(), "solDepositAuthority"),
  struct(feeFields, "solDepositFee"),
  u8("solReferralFee"),
  option(publicKey(), "solWithdrawAuthority"),
  struct(feeFields, "solWithdrawalFee"),
  option(struct(feeFields), "nextSolWithdrawalFee"),
  u64("lastEpochPoolTokenSupply"),
  u64("lastEpochTotalLamports")
]);
async function getStakePoolAccount(connection, stakePoolAddress) {
  const account = await connection.getAccountInfo(stakePoolAddress);
  if (!account) {
    throw new Error("Invalid stake pool account");
  }
  return StakePoolLayout.decode(account.data);
}
export {
  AccountType,
  StakePoolLayout,
  getStakePoolAccount
};
